import type { GeneratorOptions, Schema } from '@cli-types/core-engine/schema.js'
import type { PageGeneratorResult } from '@cli-types/next-adapter/generators.js'
import { createGeneratedFile } from '@cli-utils/files.js'
import { pluralize, toKebabCase, toPascalCase } from '@cli-utils/text.js'
import { buildLoadingSkeletonSource } from '@next-adapter/generators/emitted-helpers.js'
import { renderPageImportsTemplate } from '@next-adapter/templates/renderers/generators/page.js'

export function generatePage(
  schema: Schema,
  pagesDir: string,
  _options: GeneratorOptions = {}
): PageGeneratorResult {
  const plural = pluralize(schema.name)
  const Plural = toPascalCase(plural)
  const kebabPlural = toKebabCase(plural)

  const content = renderPageImportsTemplate({
    plural: Plural,
    kebabPlural: kebabPlural
  })
  const skeletonContent = buildLoadingSkeletonSource(`${Plural}PageSkeleton`, schema.label)

  return {
    files: [
      createGeneratedFile(`${pagesDir}/${schema.name}/page.tsx`, content),
      createGeneratedFile(
        `${pagesDir}/${schema.name}/${kebabPlural}-page-skeleton.tsx`,
        skeletonContent
      )
    ]
  }
}
